import { render, staticRenderFns } from "./ModalVoltar.vue?vue&type=template&id=72de9d0e&lang=html&"
import script from "./ModalVoltar.vue?vue&type=script&lang=js&"
export * from "./ModalVoltar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/ModalVoltar.vue
// module id = 119
// module chunks = 28